module.exports = __webpack_public_path__ + "img/conny-f-stage4-blink.2f9a826b.png";